import script from "./AppAnon.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppAnon.vue?vue&type=script&setup=true&lang=ts"

import "./AppAnon.vue?vue&type=style&index=0&id=2de7f4d5&lang=css"

const __exports__ = script;

export default __exports__